import { createSlice, createAction } from '@reduxjs/toolkit';
import initialState from '../../../domain/entities/position';

const fetchPosition = createAction('fetchPosition');

function fetchPositionSuccess(state, action) {
  const { position } = action.payload;

  state.position = position;
  state.successFetching = true;
  state.errorFetching = false;
}

function fetchPositionError(state) {
  state.position = [];
  state.successFetching = false;
  state.errorFetching = true;
}

const positionReducer = createSlice({
  name: 'position',
  initialState,
  reducers: {
    fetchPositionSuccess,
    fetchPositionError,
  },
});

export const positionActions = {
  ...positionReducer.actions,
  fetchPosition,
};

export default positionReducer.reducer;
